import { render, staticRenderFns } from "./BaseStep.vue?vue&type=template&id=73a564cb&scoped=true"
import script from "./BaseStep.vue?vue&type=script&lang=js"
export * from "./BaseStep.vue?vue&type=script&lang=js"
import style0 from "./BaseStep.vue?vue&type=style&index=0&id=73a564cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a564cb",
  null
  
)

export default component.exports